/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MonitoringTubeOverview } from "./MonitoringTubeOverview";
import {
  MonitoringTubeOverviewFromJSON,
  MonitoringTubeOverviewFromJSONTyped,
  MonitoringTubeOverviewToJSON,
  MonitoringTubeOverviewToJSONTyped,
} from "./MonitoringTubeOverview";
import type { EventsOverview } from "./EventsOverview";
import {
  EventsOverviewFromJSON,
  EventsOverviewFromJSONTyped,
  EventsOverviewToJSON,
  EventsOverviewToJSONTyped,
} from "./EventsOverview";

/**
 *
 * @export
 * @interface GMWOverview
 */
export interface GMWOverview {
  /**
   *
   * @type {string}
   * @memberof GMWOverview
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof GMWOverview
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof GMWOverview
   */
  readonly linkedGmns?: string;
  /**
   *
   * @type {string}
   * @memberof GMWOverview
   */
  standardizedLocation?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMWOverview
   */
  nitgCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMWOverview
   */
  wellConstructionDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMWOverview
   */
  qualityRegime?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMWOverview
   */
  removed?: string | null;
  /**
   *
   * @type {Array<MonitoringTubeOverview>}
   * @memberof GMWOverview
   */
  readonly tubes?: Array<MonitoringTubeOverview>;
  /**
   *
   * @type {Array<EventsOverview>}
   * @memberof GMWOverview
   */
  readonly events?: Array<EventsOverview>;
}

/**
 * Check if a given object implements the GMWOverview interface.
 */
export function instanceOfGMWOverview(value: object): value is GMWOverview {
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  return true;
}

export function GMWOverviewFromJSON(json: any): GMWOverview {
  return GMWOverviewFromJSONTyped(json, false);
}

export function GMWOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): GMWOverview {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    broId: json["bro_id"],
    linkedGmns: json["linked_gmns"] == null ? undefined : json["linked_gmns"],
    standardizedLocation:
      json["standardized_location"] === undefined
        ? undefined
        : json["standardized_location"] === null
        ? null
        : json["standardized_location"],
    nitgCode:
      json["nitg_code"] === undefined
        ? undefined
        : json["nitg_code"] === null
        ? null
        : json["nitg_code"],
    wellConstructionDate:
      json["well_construction_date"] === undefined
        ? undefined
        : json["well_construction_date"] === null
        ? null
        : json["well_construction_date"],
    qualityRegime:
      json["quality_regime"] === undefined
        ? undefined
        : json["quality_regime"] === null
        ? null
        : json["quality_regime"],
    removed:
      json["removed"] === undefined ? undefined : json["removed"] === null ? null : json["removed"],
    tubes:
      json["tubes"] == null
        ? undefined
        : (json["tubes"] as Array<any>).map(MonitoringTubeOverviewFromJSON),
    events:
      json["events"] == null
        ? undefined
        : (json["events"] as Array<any>).map(EventsOverviewFromJSON),
  };
}

export function GMWOverviewToJSON(json: any): GMWOverview {
  return GMWOverviewToJSONTyped(json, false);
}

export function GMWOverviewToJSONTyped(
  value?: Omit<GMWOverview, "uuid" | "linked_gmns" | "tubes" | "events"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bro_id: value["broId"],
    standardized_location: value["standardizedLocation"],
    nitg_code: value["nitgCode"],
    well_construction_date: value["wellConstructionDate"],
    quality_regime: value["qualityRegime"],
    removed: value["removed"],
  };
}
